import { render, staticRenderFns } from "./input-wrapper.vue?vue&type=template&id=4ef2aa9e&"
import script from "./input-wrapper.vue?vue&type=script&lang=js&"
export * from "./input-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports